<script setup lang="ts">
import AppUpdateCard from '@/components/sidebar/AppUpdateCard.vue';
import SessionsPanel from '@/components/sidebar/SessionsPanel.vue';
import SidebarLogo from '@/components/sidebar/SidebarLogo.vue';
import SidebarNav from '@/components/sidebar/SidebarNav.vue';
import UserMenu from '@/components/sidebar/UserMenu.vue';
import TenantSelector from '@/components/TenantSelector.vue';
import Separator from '@/components/ui/separator/Separator.vue';
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader
} from '@/components/ui/sidebar';
import SidebarTrigger from '@/components/ui/sidebar/SidebarTrigger.vue';

const props = defineProps<{
    isSidebarOpen: boolean;
}>();
</script>
<template>
    <Sidebar
        class="bg-background rounded-sm z-40 pt-5 pb-2 max-md:group-data-[state=expanded]:shadow-xl"
        collapsible="icon"
    >
        <div class="h-full flex flex-col gap-2 px-4">
            <SidebarHeader class="shrink-0 overflow-hidden p-0">
                <div
                    class="logo group/logo w-full mb-2 flex items-center justify-between relative h-7"
                >
                    <div
                        class="transition-all duration-300 overflow-hidden"
                        :class="
                            props.isSidebarOpen
                                ? 'w-full'
                                : 'w-6 shrink-0 absolute -left-[0.015rem] -top-1 group-hover/logo:opacity-0 max-md:opacity-0'
                        "
                    >
                        <SidebarLogo :is-sidebar-open="props.isSidebarOpen" />
                    </div>
                    <SidebarTrigger
                        class="w-[1.44rem] h-[1.44rem] p-[0.025rem] shrink-0 rounded-full transition-opacity duration-300"
                        :class="{
                            'rotate-180 opacity-0 group-hover/logo:opacity-100 max-md:opacity-100 absolute left-0 top-0.5 ':
                                !props.isSidebarOpen
                        }"
                    />
                </div>
                <TenantSelector :is-sidebar-open="props.isSidebarOpen" />
                <SidebarNav :is-sidebar-open="props.isSidebarOpen" />
            </SidebarHeader>
            <Separator class="mt-1 mb-2" />
            <SidebarContent>
                <SessionsPanel :is-sidebar-open="props.isSidebarOpen" />
            </SidebarContent>
            <SidebarFooter class="shrink-0 p-0">
                <AppUpdateCard :is-sidebar-open="props.isSidebarOpen" />
                <UserMenu :is-sidebar-open="props.isSidebarOpen" />
            </SidebarFooter>
        </div>
    </Sidebar>
</template>
